import { map, toArray, mergeMap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppServerAPI } from '@sdbn/common';
import { Identity } from '@sdbn/common';
import { ServiceResponse } from '@sdbn/common';
import { Station, TransportCreationProfile } from '../model/station.model';

@Injectable({
    providedIn: 'root'
})

export class StationService {
    constructor(private appServerAPI: AppServerAPI) { }

    getStations(): Observable<Station[]> {

        return this.appServerAPI.execute<Station[]>('/client/admin/stations/stations', {})
            .pipe(
                mergeMap(x => x),
                map(station => {
                    const newStation = new Station(station);
                    return newStation;
                }),
                toArray()
            );
    }

    createStation(station: Station): Observable<Identity> {
        return this.appServerAPI.execute<Identity>('/client/admin/stations/create', station);
    }

    updateStation(station: Station): Observable<ServiceResponse> {
        return this.appServerAPI.execute<ServiceResponse>('/client/admin/stations/update', station);
    }

    deleteStation(identity: Identity): Observable<ServiceResponse> {
        return this.appServerAPI.execute<ServiceResponse>('/client/admin/stations/delete', identity);
    }

    getTransportCreationProfiles(): Observable<TransportCreationProfile[]> {
        return this.appServerAPI.execute<TransportCreationProfile[]>('/client/admin/stations/transport-creation-profiles', {})
            .pipe(
                mergeMap(x => x),
                map(station => new TransportCreationProfile(station)),
                toArray()
            );
    }
}
